import { defineStore } from "pinia";
import * as landingApi from "../api/landing-api";
import { userLocationStore } from "@/modules/user-location";
import {
  ICouponPreview,
  IFaqItem,
  IOfferCategory,
} from "../types/frontend-types";
import { IOfferCard, IPlaceCard } from "@/package/global-types";
import { errorHandler } from "@/package/global-helpers/error-handler";

export const useLandingStore = defineStore("landing-store", {
  state: () => ({
    offersCategories: [] as Array<IOfferCategory>,
    offers: [] as Array<IOfferCard>,
    coupons: [] as Array<ICouponPreview>,
    places: [] as Array<IPlaceCard>,
    faq: [] as Array<IFaqItem>,
  }),

  actions: {
    async loadLandingPage() {
      const cityId = userLocationStore();

      try {
        const resp = await landingApi.apiGetLandingPage(cityId.city.id);
        this.offersCategories = resp.data.data.categories_offers;
        this.offers = resp.data.data.spend_offers;
        this.coupons = resp.data.data.coupons;
        this.places = resp.data.data.receive_places;
        this.faq = resp.data.data.faq;
      } catch (e: Error | unknown) {
        errorHandler(e, true);
        throw e;
      }
    },
  },
});
